import { inject, Injectable, signal } from "@angular/core";
import { getBaseUrl } from "../app/app.config";
import { SessionStorageService } from "ngx-webstorage";

@Injectable({
    providedIn: 'root',
})
export class CategoryService {
    protected readonly sessionStorageSvc = inject(SessionStorageService);
    public category = signal<string>('');

    lookupURL() {
        //get URL from address bar
        let url = getBaseUrl();
        let sessionCat: string = this.sessionStorageSvc.retrieve('currentCategory');

        if (url.includes('localhost') || url.includes('dev')) {
            //if session storage exists, use that
            if (sessionCat != null && sessionCat != undefined && sessionCat.trim() != '') {
                this.category.set(sessionCat);
            }
            //if no session storage, set to kelly as default
            //user can change in browser's dev tools if they want, so next time change/refresh page, it will use user's value.
            else {
                this.category.set('kelly');
                this.sessionStorageSvc.store('currentCategory', 'kelly');
            }
        }
        else if (url.includes('substitute')) {
            this.category.set('kelly');
        }
        else if (url.includes('contracted')) {
            this.category.set('contractor');
        }
        else if (url.includes('volunteer')) {
            this.category.set('volunteer');
        }
        else {
            this.category.set('');
        }
    }
}